import { render, staticRenderFns } from "./VTable.vue?vue&type=template&id=96aee14a&scoped=true&"
import script from "./VTable.vue?vue&type=script&lang=js&"
export * from "./VTable.vue?vue&type=script&lang=js&"
import style0 from "./VTable.vue?vue&type=style&index=0&id=96aee14a&scoped=true&lang=scss&"
import style1 from "./VTable.vue?vue&type=style&index=1&id=96aee14a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96aee14a",
  null
  
)

export default component.exports